var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.251 4.35745C15.251 1.9509 17.2019 0 19.6085 0C22.015 0 23.9659 1.9509 23.9659 4.35745C23.9659 6.764 22.015 8.71489 19.6085 8.71489C17.2019 8.71489 15.251 6.764 15.251 4.35745ZM17.4298 4.35745C17.4298 5.56072 18.4052 6.53617 19.6085 6.53617C20.8118 6.53617 21.7872 5.56072 21.7872 4.35745C21.7872 3.15417 20.8118 2.17872 19.6085 2.17872C18.4052 2.17872 17.4298 3.15417 17.4298 4.35745Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6085 10.8936C19.0069 10.8936 18.5191 11.3813 18.5191 11.983V21.7872H2.17872V5.44679H11.983C12.5846 5.44679 13.0723 4.95907 13.0723 4.35743C13.0723 3.75579 12.5846 3.26807 11.983 3.26807H1.08936C0.487724 3.26807 0 3.75579 0 4.35743V22.8766C0 23.4782 0.487724 23.9659 1.08936 23.9659H19.6085C20.2101 23.9659 20.6979 23.4782 20.6979 22.8766V11.983C20.6979 11.3813 20.2101 10.8936 19.6085 10.8936Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notificationWhite.cbfd928b0968f283cc925c81309e553a.svg";